module.exports = __webpack_public_path__ + "img/pen.4070fd8c.svg";